import React, {useEffect} from 'react';
import {useUser} from "../../../contexts/UserContext";
import {useModal} from "../../../contexts/ModalContext";
import {useNavigate, useParams} from "react-router-dom";
import AxiosConfig from "../../../services/AxiosConfig";
import Routing from "../../../services/routing";

const RedirectToSeanceAdmin = ({  }) => {
    const { user } = useUser();
    const { showModal, hideModal } = useModal();
    const { seanceId } = useParams();
    const navigate = useNavigate();

    const handleSuccess = (children = "") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    useEffect(() => {
        (async () => {
            const response = await AxiosConfig.get(`/admin/seances/${seanceId}`);
            if (response.data.success === true) {
                navigate(Routing.generate({
                    route: Routing.routes.adminSeance,
                    params: {
                        entrepriseId: response.data.entrepriseId,
                        contratId: response.data.contratId,
                        activiteId: response.data.activiteId,
                        seanceId: response.data.seanceId
                    }
                }), { state: { fromRedirect: true } });
            } else {
                handleError("Impossible de trouver la séance");
            }
        })();
    }, [seanceId]);


    return (
        <div>
            Recherche de la séance...
        </div>
    );
};

export default RedirectToSeanceAdmin;
